import React from 'react';
import { Link } from 'react-router-dom';

import landscape from './home.module.css';
import pic_home from '../pictures/Backdrop Image.avif';
import pic_home_mobile from '../pictures/Backdrop Image Mobile.webp';
import { Context } from '../services/context.js';
import { SEO, organizationJsonLd, websiteJsonLd } from '../components/SEO.jsx';

const featureHighlights = [
  {
    label: 'For brands',
    title: 'Make authenticity visible',
    text: 'Create a stronger proof story for products, ownership, and provenance without asking customers to understand blockchain internals.',
  },
  {
    label: 'For investors',
    title: 'A patent-backed platform story',
    text: 'Position Back-Step Blockchain as an infrastructure opportunity for markets where trust, auditability, and tamper evidence matter.',
  },
  {
    label: 'For partners',
    title: 'Built for real-world assets',
    text: 'Apply secure digital proof to goods, documents, certificates, and high-value transactions with a clear business narrative.',
  },
];

const marketSignals = [
  'Luxury goods and collectibles',
  'Certificates and official documents',
  'Supply chain proof',
  'Stable-value digital money concepts',
];

export default function Home() {
  const heroImage = Context.portrait ? pic_home_mobile : pic_home;

  return (
    <main className={landscape.page}>
      <SEO
        title="Back-Step Blockchain | Trust you can show"
        description="Back-Step Blockchain turns patented tamper-resistant blockchain technology into practical trust products for brands, investors, and partners."
        path="/"
        jsonLd={[organizationJsonLd, websiteJsonLd]}
      />

      <section className={landscape.hero}>
        <img className={landscape.heroImage} src={heroImage} alt="Singapore skyline, home of Back-Step Blockchain" />
        <div className={landscape.heroShade} />

        <div className={landscape.heroContent}>
          <p className={landscape.eyebrow}>Back-Step Blockchain Systems</p>
          <h1>Trust you can show, sell, and verify.</h1>
          <p className={landscape.heroText}>
            We turn blockchain security into practical proof for products, ownership, and digital value.
            The technology is complex; the business message should be simple.
          </p>

          <div className={landscape.heroActions}>
            <Link className={landscape.primaryAction} to="/products">Explore products</Link>
            <Link className={landscape.secondaryAction} to="/investors">Investor overview</Link>
          </div>
        </div>
      </section>

      <section className={landscape.intro}>
        <div className={landscape.sectionInner}>
          <p className={landscape.sectionLabel}>What it means</p>
          <h2>A trust layer for markets where proof matters.</h2>
          <p>
            Back-Step Blockchain is designed for organizations that need a stronger way to prove authenticity,
            protect value, and explain trust to customers, partners, and regulators.
          </p>
        </div>
      </section>

      <section className={landscape.highlights}>
        <div className={landscape.sectionInner}>
          {featureHighlights.map((item) => (
            <article className={landscape.highlight} key={item.title}>
              <span>{item.label}</span>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </article>
          ))}
        </div>
      </section>

      <section className={landscape.market}>
        <div className={landscape.marketCopy}>
          <p className={landscape.sectionLabel}>Market focus</p>
          <h2>From technical invention to commercial proof.</h2>
          <p>
            The site now leads with outcomes: confidence at the point of sale, evidence after transfer,
            and a clearer story for partners who need trust infrastructure.
          </p>
        </div>
        <ul className={landscape.signalList}>
          {marketSignals.map((signal) => (
            <li key={signal}>{signal}</li>
          ))}
        </ul>
      </section>

      <section className={landscape.cta}>
        <div className={landscape.sectionInner}>
          <h2>Ready to discuss a commercial use case?</h2>
          <p>
            Start with the business problem. We can map the technology to the proof, product, or investment story behind it.
          </p>
          <Link className={landscape.primaryAction} to="/contact">Contact us</Link>
        </div>
      </section>
    </main>
  );
}
